var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiveStar = function SvgFiveStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FiveStar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.957.035H18v16.8H.957Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FiveStar_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 .035h17v16.8H19Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FiveStar_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 .035h18v16.8H37Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FiveStar_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 .035h18v16.8H55Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FiveStar_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 .035h17.363v16.8H73Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FiveStar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d3af37",
      fillOpacity: 1
    },
    d: "M17.723.035H.957v16.8h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FiveStar_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d3af37",
      fillOpacity: 1
    },
    d: "M35.883.035H19.117v16.8h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FiveStar_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d3af37",
      fillOpacity: 1
    },
    d: "M54.043.035H37.277v16.8h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FiveStar_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d3af37",
      fillOpacity: 1
    },
    d: "M72.203.035H55.437v16.8h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FiveStar_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d3af37",
      fillOpacity: 1
    },
    d: "M90.363.035H73.598v16.8h16.765Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.34 11.36 2.55-.65L12.954 14Zm5.867-4.255h-4.488l-1.38-4.234-1.378 4.234H3.473L7.105 9.73l-1.378 4.235 3.632-2.625 2.235-1.61ZM27.5 11.36l2.55-.65L31.114 14Zm5.867-4.255H28.88L27.5 2.871l-1.379 4.234h-4.488l3.633 2.625-1.38 4.235 3.634-2.625 2.234-1.61ZM45.66 11.36l2.55-.65L49.274 14Zm5.867-4.255H47.04L45.66 2.871l-1.379 4.234h-4.488l3.633 2.625-1.38 4.235 3.634-2.625 2.234-1.61ZM63.82 11.36l2.551-.65L67.434 14Zm5.867-4.255H65.2L63.82 2.871l-1.379 4.234h-4.488l3.633 2.625-1.379 4.235 3.633-2.625 2.234-1.61ZM81.98 11.36l2.551-.65L85.594 14Zm5.868-4.255h-4.489L81.98 2.871l-1.378 4.234h-4.489l3.633 2.625-1.379 4.235L82 11.34l2.234-1.61Zm0 0"
  }));
};
export default SvgFiveStar;